export function formatPrice(price) {
	const formatter = new Intl.NumberFormat('nl-NL', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 0
	});

	return formatter.format(price);
}

export function jsUcfirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function arrayContains(needle, arrhaystack) {
	if (arrhaystack.length === 0) {
		return false;
	}
	return (arrhaystack.indexOf(needle) > -1);
}

export function toLetters(num) {
	var mod = num % 26,
		pow = num / 26 | 0,
		out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');
	return pow ? toLetters(pow) + out : out;
}

export function isEmpty(obj) {
	if (obj === '') {
		return true;
	}

	for (var key in obj) {
		if (obj.hasOwnProperty(key))
			return false;
	}
	return true;
}

export function formatNumber(number) {
	return new Intl.NumberFormat('nl-NL', {style: 'decimal'}).format(number);
}

export function formatBytes(a, b) {
	if (0 == a) return "0 Bytes";
	var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
		f = Math.floor(Math.log(a) / Math.log(c));
	return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
}

export function formatDate(string) {
    if ( !string || isEmpty(string)) {
		return '';
	}

	let date = new Date(string.replace(/-/g, '/'));
	return date.toLocaleDateString();

}

export function formatDateTime(string, showSeconds = false) {

	if ( !string ) {
		return;
	}

	let date = new Date(string.replace(/-/g, '/'));
	let hours = (date.getHours() < 10 ? '0' : '') + date.getHours();
	let minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    let seconds = '';
    if (showSeconds) {
        seconds = ':' + (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
    }

	return date.toLocaleDateString() + ' ' +  hours + ':' + minutes + seconds;

}

export const createFromMysql = (mysql_string) => {
    let t, result = null;

    if (typeof mysql_string === 'string') {
        t = mysql_string.split(/[- :]/);
        //when t[3], t[4] and t[5] are missing they defaults to zero
        result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
    }

    return result;
}
